import { BaseApi } from "@newview/infrastructure";

export abstract class FsServerBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'UploadApi'
    }
}